export const Routes = {
  FORGOT: 'forgot-password',
  LOGIN: 'login',
  DROPOFF: 'dropoff-dashboard',
};
